<template>
  <nav :class="$style.container">
    <div :class="$style.content">
      <img
        :class="$style.logo"
        :src="logo"
        width="12"
        alt="Hack The 6ix logo"
      />
      <ul :class="$style.items">
        <li v-for="{ name, path } in routes" :key="name">
          <router-link
            :active-class="$style[`link--active`]"
            :class="$style.link"
            :to="path"
            exact
          >
            {{ name }}
          </router-link>
        </li>
        <li>
          <div :class="$style.link" v-on:click="logout">Logout</div>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import logo from '@hackthe6ix/vue-ui/static/logo.svg';
import _routes from '../../../../router/routes';
import { runLogout } from '../../../../utils/SessionController';

export default {
  name: 'Navigation',
  data() {
    const { children } = _routes[0];
    return {
      routes: children
        .filter(({ hidden }) => !hidden)
        .reverse()
        .map(({ path, component }) => ({
          name: component.name,
          path,
        })),
      logo,
    };
  },
  methods: {
    async logout() {
      await runLogout(false);
    },
  },
};
</script>

<style src="./Navigation.module.scss" lang="scss" module />
